// extracted by mini-css-extract-plugin
export default {"svSelector":"ywilaSZecZ","svIndicator":"RN2WeFsNE0","sOverlay":"vljDK70Tuh","vOverlay":"NwQ5DcFlbU","hContainer":"CxxRt1jRmS","hSelector":"XsCpeiewfO","hIndicator":"EvS1kd0b1r"};